import { defineMessages } from 'react-intl';

export default defineMessages({
  times: {
    id: 'booking.times',
    defaultMessage: 'Times',
  },
  dates: {
    id: 'booking.dates',
    defaultMessage: 'Dates',
  },
});
